
<ng-container  >
  @if(label) {
    <label   class="s_logo-label">{{label}}
      @if(editable) {
        <ins class="s_ico s_ico-info_fill"  tooltip="SUGGESTED FORMATTING:  Size: 250px wide by 100px high Use File Types: .png,  .gif,  .jpg   Bg Color: transparent or white"></ins>
      }
     </label>
  }
    

<div [attr.id]="id" [id]="id" sl-ui-kit-dropzone [accept]="accept" (filesDropped)="onFilesAdded($event)"   class="d-inline-block" [disabled]="!editable">
  <!-- strict: removed dropdzonelabel wrapper -->
      <div [attr.role]="getButtonRole()"  class="s_logo-box" [style]="imageContainerStyle">
        @if(src) {
          <img  [src]="src" (load)="onImageLoad()" [style]="loading? 'display:none' : 'display:inline-block'">
        }
       
      </div>
 
  
  </div> 
  </ng-container>